module.exports = __webpack_public_path__ + "static/img/11.4e6d235.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/11.png
// module id = 7mv+
// module chunks = 0